import { render } from "./VitAccordionGroup.vue?vue&type=template&id=1f03b73b&ts=true"
import script from "./VitAccordionGroup.vue?vue&type=script&lang=ts"
export * from "./VitAccordionGroup.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__